import { Building2 } from "lucide-react";

import { useProjectFilter } from "../../hooks/useProjectFilter";
import { cn } from "../../lib/utils";
import { Label } from "../ui/label";

import LazySearchSelect from "./LazySearchSelect";

const ProjectFilter = ({
  selectedProject: propSelectedProject,
  onProjectChange,
  plain = false,
  className,
  fullWidth = false,
  showLabel = true
}) => {
  const { projectId, updateProject } = useProjectFilter();

  // Use props if provided (controlled), otherwise use the hook (global sync)
  const currentProject = propSelectedProject !== undefined ? propSelectedProject : projectId;

  const handleValueChange = (value) => {
    const nextId = value === "all" ? "ALL" : value;
    if (onProjectChange) {
      onProjectChange(nextId);
    } else {
      updateProject(nextId);
    }
  };

  const content = (
    <div className={cn("flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3", className)}>
      {showLabel && (
        <div className="flex items-center gap-2 text-yale-blue-600 dark:text-yale-blue-400">
          <Building2 className="w-4 h-4 shrink-0" />
          <Label className="font-bold text-[10px] uppercase tracking-wider whitespace-nowrap">Project</Label>
        </div>
      )}
      <div className={cn("w-full", !fullWidth && "sm:w-[240px]")}>
        <LazySearchSelect
          value={currentProject === "ALL" ? "all" : currentProject}
          onChange={handleValueChange}
          placeholder="All projects"
          searchPlaceholder="Search projects..."
          apiUrl="/projects"
          showAllOption={true}
          allOptionLabel="All Projects"
          pageSize={20}
          icon={Building2}
          popoverWidth="w-[300px] sm:w-[450px]"
          renderItem={(project) => (
            <div className="flex items-center gap-2 py-1 px-0.5 min-w-0">
              <div className="p-1 rounded-md bg-yale-blue-50 dark:bg-yale-blue-900/50 text-yale-blue-600 dark:text-yale-blue-400 shrink-0">
                <Building2 className="w-3.5 h-3.5" />
              </div>
              <span className="font-semibold text-sm truncate text-slate-900 dark:text-slate-100">{project.name}</span>
            </div>
          )}
        />
      </div>
    </div>
  );

  if (plain) {
    return content;
  }

  return (
    <div
      className={cn(
        "flex items-center gap-4 bg-white dark:bg-yale-blue-900 p-3 px-4 rounded-xl shadow-sm border border-slate-200 dark:border-yale-blue-800 md:w-fit",
        fullWidth ? "w-full" : "w-full md:w-fit"
      )}
    >
      {content}
    </div>
  );
};

export default ProjectFilter;
